import React,{useEffect, useState, useRef} from 'react';

import CustomDropdown from '../dropdown-main/DropdownMain';


import './sort-button.scss';

const sortOrderDropdownItems = [
    {
        name: 'Ascending',
        id: 0
    },
    {
        name: 'Descending',
        id: 1
    }]


const SortButton = ({
        headerText,
        sortOptionsItems,
        sortData: {
            sortSelection,
            sortOrder
        },
        updateSortOrder,
        updateSortSelection,
        clearFilter}) => {

    const [isSorting,setIsSorting] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const sortButtonRef = useRef(null);

    useEffect(() => {
        if(!sortSelection){
            setIsSorting(false);
            return;
        }

        setIsSorting(true);
    }, [sortSelection])

    useEffect(() => {
        document.addEventListener("mousedown", handleDropdownOpen);
        return () => {
            document.removeEventListener("mousedown", handleDropdownOpen);
        };
    }, [])

    const handleDropdownOpen = (event) => {
        if(sortButtonRef.current.contains(event.target)){
            setIsDropdownOpen(true);
            return;
        }

        setIsDropdownOpen(false);
    }

    return(
        <div ref = {sortButtonRef} className = 'table-sort-button' >
            <div className = {`button-container ${isSorting  || isDropdownOpen ? 'active-background' : ""}`}>
                <div
                    className = 'sort-icon'
                    id = {'activated-sort'}>
                </div>
                <div
                    className = 'sort-label'
                    id = {'activated-sort-text'}>
                        Sort by: {sortSelection ? sortSelection.name : 'None'}
                </div>
            </div>

            {
                isDropdownOpen &&
                    <div className = 'sort-dropdown'>
                        <div className="header-container">
                            <span className = 'sort-title'>{ headerText}</span>
                            <button className="clear-button" onClick={clearFilter} disabled={isSorting ? false : true }>
                                Clear
                            </button>
                        </div>
                        <hr className="divider"/>
                        <div className='sort-selection-container'>
                            <div className = 'sort-selection-dropdown'>
                                <CustomDropdown
                                    values = {sortOptionsItems}
                                    onSelect={(selectedSortOption) => updateSortSelection(selectedSortOption)}
                                    currentSelected={sortSelection}/>
                            </div>
                            <div className = 'sort-order-dropdown'>
                                <CustomDropdown
                                    values = {sortOrderDropdownItems}
                                    placeHolderText='Select a sort'
                                    onSelect={(selectedOrder) => updateSortOrder(selectedOrder)}
                                    currentSelected={sortOrder}/>
                            </div>
                            <div className = 'close-container'>
                                <button
                                    className = 'close-button'
                                    onClick = {clearFilter}>
                                </button>
                            </div>
                        </div>
                    </div>
            }
        </div>
    )
}

export default SortButton;